import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';
import TinymceEditorComponent from '72cms-ui/components/form-elements/TinymceEditorComponent';
import PageBuilderComponent from '72cms-ui/components/helpers/PageBuilderComponent';

export default {
    sections: ['details', 'thumbnail', 'header', 'meta data'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    groups: {
        category_details: {
            component: {
                template: `<div>
                    <div class="form-row"><slot name="parent_id" /></div>
                    <div class="form-row"><slot name="name" /></div>
                    <hr>
                </div>`
            }
        },
        content_details: {
            component: PageBuilderComponent,
            showOnSection: 'details',
        },
    },
    fields: {
        parent_id: {
            label: 'Parent category',
            section: 'details',
            group: 'category_details',
            position: 0,
            cssClass: "col-md-6",
        },
        name: {
            section: 'details',
            group: 'category_details',
            position: 1,
            cssClass: "col-md-6",
        },
        content: {
            section: 'details',
            group: 'content_details',
            position: 3,
            // component: TinymceEditorComponent,
        },

        image: {
            section: 'thumbnail',
            description: 'Please resize images to 800px x 642px prior to uploading. The filesize of your image should not exceed <strong>10MB</strong>.',
            position: 0,
        },

        header_image: {
            section: 'header',
            description: 'Please resize images to 1800px x 550px prior to uploading. The filesize of your image should not exceed <strong>10MB</strong>.',
            position: 0,
        },

        title: {
            section: 'meta data',
            position: 0,
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = entry.newValue;
                }
            }
        },
        name_id: {
            label: 'Page URL',
            section: 'meta data',
            prefix: function (value, schema, data) {
                let path = _.get(data, 'path', '');
                path = path.split('/').slice(0, -1).join('/');
                return path ? `/${path}/` : '/';
            },
            position: 1,
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = V.slugify(entry.newValue);
                }
            }
        },
        meta_description: {
            section: 'meta data',
            position: 2,
            component: ExpandableTextComponent,
        },
        meta_keywords: {
            section: 'meta data',
            position: 3,
            component: ExpandableTextComponent,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.category.js